const User = require('../class/user');
const user = new User();

module.exports = user;